import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import { setEdgeServers } from '../../../../shared/lib/setEdgeServers'
import {
  useDeleteDishesToFotoboxesMutation,
  useSendDishesToFotoboxesMutation,
} from '../../../../core/api/BuffetDishApi'

export const useUpdateDishStations = (
  oldValue: IEdgeServers[],
  newValue: IEdgeServers[],
) => {
  const { deletedItems, addedItems } = setEdgeServers(oldValue, newValue) || {}
  const [sendDishesToFotoboxes] = useSendDishesToFotoboxesMutation()
  const [deleteDishesToFotoboxes] = useDeleteDishesToFotoboxesMutation()

  const onUpdateStation = (dishGuid: string) => {
    if (
      deletedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      deleteDishesToFotoboxes({
        dishesGuids: [dishGuid],
        edgeServersGuids: deletedItems,
      })
    }
    if (
      addedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      sendDishesToFotoboxes({
        dishesGuids: [dishGuid],
        edgeServersGuids: addedItems,
      })
    }
  }
  return { onUpdateStation }
}
